<template>
  <div v-if="isHubArea">
    <div class="row split" @click="onSelectTime">
      <img src="../../../assets/img-v2/ic_home_time.png" class="icon" />
      <div class="label">{{ showLabel }}</div>
      <img v-if="isBookingTicket" src="../../../assets/img-v2/ic_home_arrow_right.png" class="arrow" />
    </div>

    <DatetimePicker
      v-model="pickerVisible"
      :defaultIndex="defaultIndex"
      :columns="columns"
      @confirm="onPickerOk"
      @cancel="onPickerCancel"
    />
  </div>
</template>
<script>
import DatetimePicker from "./DatetimePicker.vue";
import { dateToChinese } from "@/utils";
import { getDateAndTime } from "@/views/home/util";
import dayjs from "dayjs";
import { mapGetters } from "vuex";

export default {
  model: {
    prop: "dateTime",
    event: "change",
  },
  props: {
    dateTime: {
      type: String,
      default: "",
    },
  },
  components: {
    DatetimePicker,
  },
  data() {
    return {
      pickerVisible: false,
      defaultIndex: 0,
    };
  },
  computed: {
    ...mapGetters({
      isHubArea: "run/isHubArea", // 是否枢纽站模式
      isBookingTicket: "run/isBookingTicket", // 是否预约单
      preTimeList: "run/preTimeList", // 预约单时间段
    }),
    showLabel() {
      if (this.isBookingTicket) {
        if (this.dateTime) {
          const { time } = getDateAndTime(this.dateTime) || {};
          return time || "";
        } else {
          return "选择时间";
        }
      } else {
        return "随时出发";
      }
    },
    validTimeList() {
      return (this.preTimeList || []).filter(
        (item) =>
          item.date &&
          (dayjs().isBefore(item.date, "day") ||
            dayjs().isSame(item.date, "day"))
          && item.times.length > 0
      );
    },
    columns() {
      return this.validTimeList.map((item) => {
        const times = item.times || [];
        const { date, time } = getDateAndTime(this.dateTime) || {};
        const idx = times.findIndex((t) => t === time);
        return {
          label: dateToChinese(item.date, "M月D日"),
          value: item.date,
          defaultIndex: item.date === date ? Math.max(idx, 0) : 0,
          children: times.map((time) => {
            return {
              label: time,
              value: time,
            };
          }),
        };
      });
    },
  },
  watch: {
    dateTime(val) {
      if (val) {
        const { date } = getDateAndTime(val) || {};
        const idx = this.validTimeList.findIndex((item) => item.date === date);
        this.defaultIndex = Math.max(idx, 0);
      } else {
        this.defaultIndex = 0;
      }
    },
  },
  methods: {
    onSelectTime() {
      if (this.isBookingTicket) {
        this.pickerVisible = true;
      } else {
        this.pickerVisible = false;
      }
    },
    onPickerOk(val) {
      this.$emit("change", val);
      this.onPickerCancel();
    },
    onPickerCancel() {
      this.pickerVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  position: relative;

  &::after {
    content: "";
    display: block;
    width: 1px;
    height: 20px;
    background: #e5e5e5;
    position: absolute;
    right: 0;
  }
}

.icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.label {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.arrow {
  width: 12px;
  height: 12px;
  margin-left: 4px;
}
</style>
